import React, { Component } from 'react'
import Home2 from './Home.page2';
import Home from './Home.page';

export default class HomePage extends Component {
   constructor(props){
      super(props);
      this.state = {
         component : window.innerWidth > 768 ? <Home/> : <Home2 />
      }
      this.checkSize = () => {
         if (window.innerWidth > 768){
            this.setState({
               component: <Home />
            })
         }
         else {
            this.setState({
               component: <Home2 />
            })
         }
      }
   }

   componentDidMount(){
      this.timer = setInterval(() => {
         this.checkSize()
      }, 100);
   }

   componentWillUnmount(){
      clearInterval(this.timer)
   }

   render() {
      return (
         <>
            {this.state.component}
         </>
      )
   }
}
